import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { RecordUrl } from '../types';
import { Subscriber } from 'rxjs/Subscriber';
import { RecorderStore } from './stores/recorder.store';
import { ShareService } from './services/share.service';
import { Recorder } from './entities/recorder';
import { Player } from './entities/player';
import { ModalComponent } from '../shared/components/modal/modal.component';

@Component({
  selector: 'app-rec',
  templateUrl: './rec.component.html',
  styleUrls: ['./rec.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class RecComponent implements OnInit, OnDestroy {
  recordUrl: RecordUrl;
  onRecordUrlSubscriber: Subscriber<RecordUrl>;

  @ViewChild(ModalComponent) shareModal: ModalComponent;

  constructor(
    private recorderStore: RecorderStore,
    private shareService: ShareService,
    private recorder: Recorder,
    private player: Player,
  ) {
  }

  ngOnInit() {
    this.onRecordUrlSubscriber = this.shareService.onRecordUrl
      .subscribe(recordUrl => this.onRecordUrl(recordUrl));
  }

  ngOnDestroy() {
    this.onRecordUrlSubscriber.unsubscribe();
  }

  get playback(): boolean {
    return this.player.playback;
  }

  get recording(): boolean {
    return this.recorder.recording;
  }

  get noRecord(): boolean {
    return this.recorderStore.recordData.length === 0;
  }

  get singleLayer(): boolean {
    return this.recorderStore.recordData.layerIds.length === 1;
  }

  onRecordUrl(recordUrl: RecordUrl) {
    this.recordUrl = recordUrl;
    this.shareModal.openModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/rec.component.ts